<template>
    <div class="thirdStep">
      <div class="flieName_box">
        <div class="btn">
          <label>成绩单名称：</label>
          <el-input v-model="obj.origName" ></el-input>
        </div>
      </div>
      <div class="table_box">
        <div class="upload_box">
          <p>成功上传信息<span style="color:#1890FF">{{allPage}}</span>条 错误信息<span style="color:#EC3441">{{errPage}}</span>条</p>
          <p>
            <a href="javascript:;" class="change-btn" @click="batchDeleted">批量删除</a>
            <a href="javascript:;" class="change-btn" @click="allDerive">批量导出</a>
          </p>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%;" :header-cell-style="{background:'#F4F8FE',padding:'8px 0',color:'#191919'}" v-el-table-infinite-scroll="load" v-if="compile">
          <el-table-column  show-overflow-tooltip type="selection" :selectable='checkboxT' width="55" align="center">
          </el-table-column>
          <el-table-column
                  label="序号"
                  type="index"
                  width="50"
                  align="center">
          </el-table-column>
          <template v-for="(item,index) in tableHead">
            <el-table-column :key="index" :prop="item.key" align="center" :label="item.value" min-width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.info.indexOf(item.error) != -1 ">
                  <div class="table-compile" v-if="!scope.row.isCompile">
                    <span :title="scope.row[item.key]">{{scope.row[item.key] || ' '}}</span><img src="../../../assets/compile_icon.svg" alt="" @click="compileBtn(scope.row)">
                  </div>
                  <el-input ref="inputFocus" v-else v-model="scope.row[item.key]" @blur="completeFun(scope.row)" ></el-input>
                </div>
                <span v-else class="overSpan" :title="scope.row[item.key]">{{scope.row[item.key]}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-for="(item,index) in tableSubject">
            <el-table-column :key="index" :prop="item.key" align="center" :label="item.name" min-width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.info.indexOf(item.name) != -1 ">
                  <div class="table-compile" v-if="!scope.row.isCompile">
                    <span :title="scope.row.subject[index].score">{{scope.row.subject[index].score || ' '}}</span><img src="../../../assets/compile_icon.svg" alt="" @click="compileBtn(scope.row,index)">
                  </div>
                  <el-input ref="inputFocus" v-else v-model="scope.row.subject[index].score" @blur="completeFun(scope.row,index)" ></el-input>
                </div>
                <span v-else class="overSpan" :title="scope.row.subject[index].score">{{scope.row.subject[index].score}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-if="potionts">
            <el-table-column align="center" :label="$parent.tableHead.totalPoints">
              <template slot-scope="scope">
                <div v-if="scope.row.info.indexOf('总分') != -1 ">
                  <div class="table-compile" v-if="!scope.row.isCompile">
                    <span>{{scope.row.totalPoints || ' '}}</span><img src="../../../assets/compile_icon.svg" alt="" @click="compileBtn(scope.row,index)">
                  </div>
                  <el-input ref="inputFocus" v-else v-model="scope.row.totalPoints" @blur="completeFun(scope.row)"  ></el-input>
                </div>
                <span v-else class="overSpan" :title="scope.row.totalPoints">{{scope.row.totalPoints}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-for="(item,index) in tableCus">
            <el-table-column :key="index" :prop="item.key" align="center" :label="item.name" min-width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.info.indexOf(item.name) != -1 ">
                  <div class="table-compile" v-if="!scope.row.isCompile">
                    <span :title="scope.row.cus[index].customValue">{{scope.row.cus[index].customValue || ' '}}</span><img src="../../../assets/compile_icon.svg" alt="" @click="compileBtn(scope.row,index)">
                  </div>
                  <el-input ref="inputFocus" v-else v-model="scope.row.cus[index].customValue" @blur="completeFun(scope.row,index)" ></el-input>
                </div>
                <span v-else class="overSpan" :title="scope.row.cus[index].customValue">{{scope.row.cus[index].customValue}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" :min-width='120'>
            <template slot-scope="scope">
              <a href="javascript:;" class="list-btn" style="border-right:none"   @click="compilefun(scope.row)">编辑</a>
              <el-popconfirm
                confirmButtonText='好的'
                cancelButtonText='不用了'
                icon="el-icon-info"
                iconColor="red"
                title="确定删除该条信息吗？"
                @onConfirm="del(scope.row)"
              >
                 <a href="javascript:;" slot="reference" class="list-btn" style="border-right:none" >删除</a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn_box">
        <a href="javascript:;" class="border-btn" @click="setActive(2)">上一步</a>
        <a href="javascript:;" class="change-btn" @click="allImport">完成</a>
      </div>

      <el-dialog
        title="编辑"
        v-if="dialog"
        :visible.sync="dialog"
        width="739px"
        center>
        <el-form :model="form" label-width="80px" label-position="left" style="padding:0 40px;overflow: hidden;">
          <el-row :gutter="20">
            <el-col span="12" v-for="(item,index) in tableHead.slice(1)" :key="index">
              <el-form-item :label="item.value">
                <el-input v-model="form[item.key]"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12" v-for="(item,index) in tableSubject" :key="index">
              <el-form-item :label="item.name">
                <el-input v-model="form.subject[index].score"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12" v-if="potionts">
              <el-form-item label="总分">
                <el-input v-model="form.totalPoints"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12" v-for="(item,index) in tableCus" :key="index">
              <el-form-item :label="item.name">
                <el-input v-model="form.cus[index].customValue"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog = false">取 消</el-button>
          <el-button type="primary" @click="submitBtn">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
import { getTranscriptExcel,updateExcel,detelExcel,importDate,excelExport } from '@/api/common_api'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
export default {
  data(){
    return{
      name:'',
      dialog:false,
      form:{},
      tableData:[],
      compile:false,
      limit: 10,
      offset: 1,
      total:0,
      tableHead:[
        {
          value: '错误信息',
          key: 'info',
        },
        {
          value: this.$parent.tableHead.code,
          key: 'code',
          error:'学号'
        },
        {
          value:this.$parent.tableHead.name,
          key: 'studentName',
          error:'姓名'
        }
      ],
      allPage:0,
      errPage:0,
      tableSubject: [],
      tableCus:[],
      potionts:false,
      tableStudent:[],
    }
  },
  props:{
    obj:{
      type:Object
    }
  },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  created(){
    this.getTable()
  },
  methods:{
    getTable(){
      let obj = JSON.parse(JSON.stringify(this.obj))
      obj.transcriptId = ""
      getTranscriptExcel(this.obj).then(res=>{
        if(res.s==1){
          let  data = res.d,tableSubject=[],tableCus=[],errPage=0
          if(data.length){
             data[0].subject.map(val=>{
               tableSubject.push({name:val.subjectName})
               return val
             })
             data[0].cus.map(val=>{
               tableCus.push({name:val.customName})
             })
             this.potionts = data[0].hasOwnProperty('totalPoints')
             this.tableCus = tableCus
             this.tableSubject = tableSubject
          }
          res.d.map(val=>{
            val.isCompile = false
            val.info = val.info?val.info:''
            if(val.info.length){
              errPage++
            }
            return val
          })
          this.allPage = res.d.length-errPage
          this.errPage = errPage
          this.compile=true
          this.tableData = data
        }
      })
    },
    //导入到正式表
    allImport(){
      if(!this.obj.origName.length){
        this.$message.error('请先填写成绩单名称')
        return false
      }

      if(this.errPage){
        this.$confirm('还有错误信息未处理，如果急需完成成绩单，则系统会自动删除错误数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveDate()
        })
      }else{
        this.saveDate()
      }

      
    },
    saveDate(){
      let obj={
        queryName:this.obj.queryName,
        subName:this.obj.subjectName,
        cusName:this.obj.customName,
        origName:this.obj.origName
      }
      importDate(obj).then(res=>{
        if(res.s==1){
          this.$alert('成功上传成绩单', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push('/')
            }
          });
        }
      })
    },
    //批量导出
    allDerive(){
      let obj={
        queryName:this.obj.queryName,
        subName:this.obj.subjectName,
        cusName:this.obj.customName,
        origName:this.obj.origName
      }
      excelExport(obj).then(res =>{
        if(res.s == 1){
          this.$message({
            message: '导出文件成功',
            type: 'success'
          })
          this.$notify({
            title: `导出文件成功`,
            type: 'success',
            dangerouslyUseHTMLString: true,
            duration: 3000,
            offset: 60,
            message: `<iframe src='${window.location.origin+res.d.filePath}' style="display:none"></iframe>`
          })
        }else{
          this.$message.error(res.d)
        }
      })
    },
    //批量删除
    batchDeleted(){
      let data=this.$refs.multipleTable.store.states.selection,ary
      ary = data.map(val=>{
        return val.id
      })
      if(!ary.length){
        this.$message.error('请选择数据')
        return false
      }
      let obj={
        queryName:this.obj.queryName,
        subjectName:this.obj.subjectName,
        customName:this.obj.customName,
        type:1,
        ids:ary.join(',')
      }
      detelExcel(obj).then(res=>{
        if (res.s == 1) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTable()
        } else {
          this.$message.error(res.d)
        }
      })
      
    },
    //删除按钮
    del(row){
      let obj={
        queryName:this.obj.queryName,
        subjectName:this.obj.subjectName,
        customName:this.obj.customName,
        type:1,
        id:row.id
      }
      detelExcel(obj).then(res=>{
        if (res.s == 1) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTable()
        } else {
          this.$message.error(res.d)
        }
      })
    },
    //编辑按钮
    compilefun(row){
      this.form = row
      this.dialog = true
    },
    // 单元格修改
    compileBtn (row) {
      row.isCompile = true
      this.$forceUpdate()
    },
    //基本数据修改
    completeFun(row){
      this.$forceUpdate()
      let rows = JSON.parse(JSON.stringify(row))
      rows.queryName = this.obj.queryName
      rows.subjectName = this.obj.subjectName
      rows.customName = this.obj.customName
      rows.isCompile = false
      this.upDate(rows)
    },
    submitBtn(){
      this.form.queryName = this.obj.queryName
      this.form.subjectName = this.obj.subjectName
      this.form.customName = this.obj.customName
      this.upDate(this.form)
    },
    upDate(obj){
      let form = JSON.parse(JSON.stringify(obj)),msg='';
      form.subject.map((item,index)=>{
        form[`subject[${index}].id`] = item.id
        form[`subject[${index}].score`] = item.score
        form[`subject[${index}].subjectId`] = item.subjectId
        form[`subject[${index}].subjectName`] = item.subjectName
        if(!this.Number(item.score)){
          msg = '课程分数只能为数字'
        }
      })
      if(form.totalPoints){
        if(!this.Number(form.totalPoints)){
          msg = '总分只能为数字'
        }
      }
      if(msg.length){
        this.$message.error(msg)
        return false
      }
      
      form.cus.map((item,index)=>{
        form[`cus[${index}].id`] = item.id
        form[`cus[${index}].customName`] = item.customName
        form[`cus[${index}].customValue`] = item.customValue
      })
      delete form.subject
      delete form.cus
      updateExcel(form).then(res => {
        if(res.s == 1){
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        }else{
          this.$message.error(res.d)
        }
        this.dialog = false
        this.getTable()
      }).catch(e=>{
        this.getTable()
      })
    },
    load() {
      // if(this.tableData.length>=this.total && this.compile){
      //   return false
      // }
      // this.offset++
      // this.getTable()
    },
    //编辑
    compile(item){
      this.dialog = true
    },
    Number(val) {
  　　if (parseFloat(val).toString() == "NaN") {
  　　　　return false;
  　　} else {
  　　　　return true;
  　　}
    },
    setActive(val){
      this.$parent.setActive(val)
      let obj={
        queryName:this.obj.queryName,
        subjectName:this.obj.subjectName,
        customName:this.obj.customName,
        type:3
      }
      detelExcel(obj).then(res=>{
        
      })
    }
  }
}
</script>
<style lang="less" scoped>
.thirdStep{
  font-size: 14Px;
  margin-top: 24Px;
  .flieName_box{
    display: flex;
    justify-content: space-between;
    .btn{
      margin-left: 7Px;
      /deep/ .el-input{
        width: 224Px;
        margin-right: 14Px;
      }
    }
  }
  .table_box{
    width: 805Px;
    .upload_box{
      display: flex;
      justify-content: space-between;
      line-height: 36Px;
      margin: 20Px 0 16Px 0;
      padding-left: 7Px;
      a{
        margin-left: 30Px;
        margin-right: 4Px;
      }
    }
    /deep/ .el-table td{
      padding: 4Px 0;
    }
  }
  .btn_box{
    margin-top: 36Px;
    text-align: center;
    .change-btn{
      margin-left: 34Px;
    }
  }
}

/deep/ .el-table .cell{
  padding: 0;
}

</style>